import { format } from "date-fns";
import { Briefcase, Megaphone, Send, TrendingUp } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useCampaigns } from "@/features/campaigns/api/useCampaigns";
import MetricCard from "@/features/campaigns/jobboards/components/MetricCard";
import { useActiveCampaignIntegrationCount } from "@/features/home/api/useActiveCampaignIntegrationCount";
import { useIntegrations } from "@/features/integrations/hooks/useIntegrations";
import { useVacancies } from "@/features/vacancies/api/useVacancies";
import { useValueFormatter } from "@/utils/useValueFormatter";

export function KpiTiles({ clientId }: { clientId?: string }) {
  const { t } = useTranslation();
  const { format: formatValue } = useValueFormatter();

  const today = format(new Date(), "yyyy-MM-dd");
  const campaigns = useCampaigns({
    page: 1,
    pageSize: 1,
    clientId,
    activeFrom: today,
    activeTo: today,
  });
  const vacancies = useVacancies({ page: 1, pageSize: 1, clientId });
  const activeJobboards = useActiveCampaignIntegrationCount(clientId);
  const directApply = useIntegrations({
    clientId,
    isActive: true,
    hasModule: "direct-apply",
  });

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <MetricCard
        variant="gradient"
        icon={<Megaphone className="size-5 text-primary" />}
        label={t("home.kpi.activeCampaigns")}
        value={formatValue(campaigns.data?.totalRecords ?? null, "whole")}
        isLoading={campaigns.isLoading}
      />
      <MetricCard
        variant="gradient"
        icon={<Briefcase className="size-5 text-primary" />}
        label={t("home.kpi.activeVacancies")}
        value={formatValue(vacancies.data?.totalRecords ?? null, "whole")}
        isLoading={vacancies.isLoading}
      />
      <MetricCard
        variant="gradient"
        icon={<TrendingUp className="size-5 text-primary" />}
        label={t("home.kpi.activeJobboards")}
        value={formatValue(activeJobboards.count ?? null, "whole")}
        isLoading={activeJobboards.isLoading}
      />
      <MetricCard
        variant="gradient"
        icon={<Send className="size-5 text-primary" />}
        label={t("home.kpi.activeDirectApply")}
        value={formatValue(directApply.data?.length ?? null, "whole")}
        isLoading={directApply.isPending}
      />
    </div>
  );
}
